import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import invoiceConstants from "../constants/invoiceConstants";

const getInvoices = (payload: any) =>
  api.get(Endpoint.retrieveInvoices, {
    params: {
      ...(payload.clientId && { client: payload.clientId }),
      page: payload.page,
      ...(payload.searchText && { search: payload.searchText }),
      ...(payload.currency && { currency_name: payload.currency }),
      ...(payload.status && { status: payload.status }),
      ...(payload.dateRange &&
        payload.dateRange.from && {
          created_at_after: payload.dateRange.from,
          created_at_before: payload.dateRange.to,
        }),
    },
  });

const getInvoiceDetails = (payload: any) =>
  api.get(`${Endpoint.retrieveInvoiceDetails}/${payload.id}/`);

const createInvoice = (payload: any) =>
  api.post(Endpoint.createInvoice, payload);

const sendInvoice = (payload: any) =>
  api.post(
    `${Endpoint.sendInvoice}/${payload.id}/send-email-invoice/`,
    payload.body,
  );

const updateInvoice = (payload: any) =>
  api.patch(`${Endpoint.updateInvoice}/${payload.id}/`, {
    ...(payload.status && { status: payload.status }),
    ...(payload.notes && { notes: payload.notes }),
    ...(payload.reference && {
      reference: payload.reference === "DEFAULT" ? "" : payload.reference,
    }),
  });

function* getInvoicesAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getInvoices, action.payload);

    yield put({
      type: invoiceConstants.GET_INVOICES_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: invoiceConstants.GET_INVOICES_FAILURE, err: e });
  }
}

function* getInvoiceDetailsAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getInvoiceDetails,
      action.payload,
    );

    yield put({
      type: invoiceConstants.GET_INVOICE_DETAILS_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: invoiceConstants.GET_INVOICE_DETAILS_FAILURE, err: e });
  }
}

function* sendInvoiceAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(sendInvoice, action.payload);

    yield put({
      type: invoiceConstants.SEND_INVOICE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: invoiceConstants.SEND_INVOICE_FAILURE, err: e });
  }
}

function* createinvoiceAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(createInvoice, action.payload);

    yield put({
      type: invoiceConstants.CREATE_INVOICE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: invoiceConstants.CREATE_INVOICE_FAILURE, err: e });
  }
}

function* updateInvoiceAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(updateInvoice, action.payload);

    yield put({
      type: invoiceConstants.UPDATE_INVOICE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: invoiceConstants.UPDATE_INVOICE_FAILURE, err: e });
  }
}

function* invoiceSaga() {
  yield all([
    takeEvery(invoiceConstants.GET_INVOICES_REQUEST, getInvoicesAsync),
  ]);
  yield all([
    takeEvery(
      invoiceConstants.GET_INVOICE_DETAILS_REQUEST,
      getInvoiceDetailsAsync,
    ),
  ]);
  yield all([
    takeEvery(invoiceConstants.SEND_INVOICE_REQUEST, sendInvoiceAsync),
  ]);
  yield all([
    takeEvery(invoiceConstants.CREATE_INVOICE_REQUEST, createinvoiceAsync),
  ]);
  yield all([
    takeEvery(invoiceConstants.UPDATE_INVOICE_REQUEST, updateInvoiceAsync),
  ]);
}

export default invoiceSaga;
